var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpTicketIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8716_9928)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13127 2.54606C5.47332 2.54606 2.50798 5.51141 2.50798 9.16935C2.50798 12.8273 5.47332 15.7926 9.13127 15.7926C12.7892 15.7926 15.7546 12.8273 15.7546 9.16935C15.7546 5.51141 12.7892 2.54606 9.13127 2.54606ZM1.03613 9.16935C1.03613 4.69853 4.66045 1.07422 9.13127 1.07422C13.6021 1.07422 17.2264 4.69853 17.2264 9.16935C17.2264 13.6402 13.6021 17.2645 9.13127 17.2645C4.66045 17.2645 1.03613 13.6402 1.03613 9.16935Z",
    fill: "#67768E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13143 5.49023C9.53787 5.49023 9.86735 5.81972 9.86735 6.22616V12.1135C9.86735 12.52 9.53787 12.8494 9.13143 12.8494C8.72499 12.8494 8.39551 12.52 8.39551 12.1135V6.22616C8.39551 5.81972 8.72499 5.49023 9.13143 5.49023Z",
    fill: "#67768E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45166 9.16951C5.45166 8.76308 5.78114 8.43359 6.18758 8.43359H12.075C12.4814 8.43359 12.8109 8.76308 12.8109 9.16951C12.8109 9.57595 12.4814 9.90544 12.075 9.90544H6.18758C5.78114 9.90544 5.45166 9.57595 5.45166 9.16951Z",
    fill: "#67768E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8716_9928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6621,
    height: 17.6621,
    fill: "white",
    transform: "translate(0.300293 0.337891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpTicketIcon);
export default __webpack_public_path__ + "static/media/HelpTicketIcon.058378edd409828bb49be48aea936517.svg";
export { ForwardRef as ReactComponent };